import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/auth", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        if (data.token) setToken(data.token);
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.profile_complete ? "/" : "/profile", { replace: true });
      } catch {
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="h-[100dvh] w-full flex flex-col items-center justify-center bg-[#0D0C12] gap-4">
      <Loader2 className="w-8 h-8 text-rose-500 animate-spin" />
      <p className="text-slate-400 text-sm">Signing you in…</p>
    </div>
  );
}
